import productsApi from '~/pages/api/services/products-api';

export async function getListMenuEvent(locale: string) {
  let result: any[] = [];
  await productsApi.getListProductsDealEvent().then(res => {
    if (res?.status !== 200) {
      throw res;
    }
    const {data} = res;
    result = data;
  });
  return result;
}
